module.exports = __webpack_public_path__ + "static/media/birds.0d5d1011.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/birds.png
// module id = 30
// module chunks = 0